import type { Patient } from '../types';
import patientsData from './mockPatients.json';

export const mockPatients: Patient[] = patientsData as Patient[];
